<template>
  <div class="body">
    dsfsdfdsf
    <!--  筛选条件 -->
    <div class="navigation-line contents">
      <div class="contents navigation-contents">
        <p class="navigation">
          <i class="icon iconfont icon-yuanquan_huaban1"></i>
          <span class="nowshow">当前位ss置：</span>

          <router-link class="navigation-now" tag="a" :to="{ name: 'index' }"
            >首页</router-link
          >
          <i class="icon iconfont icon-youjiantou"></i>
          <router-link
            class="navigation-now"
            tag="a"
            :to="{ name: 'brandList' }"
            >品牌</router-link
          >
          <i class="icon iconfont icon-youjiantou"></i>
          <span class="navigation-now">{{ brandInfo.name }}</span>
        </p>
      </div>
      <!-- 品牌列表 -->
      <Brandlist :brandId="brandId"></Brandlist>
      <brandsearch
        :brandClassList="brandClassList"
        @checkClass="checkClass"
        @checkitemClass="checkitemClass"
        :brandInfo="brandInfo"
        @reset="reset"
      ></brandsearch>
    </div>
    <!--  筛选条件结束 -->

    <!-- 商品列表 -->
    <div class="contents-goods-box" id="goodslist">
      <div class="contents">
        <div class="goods-box">
          <!-- <user-collection-info :pagesize="pagesize" :iconon="iconon" :iconoff="iconoff"/> -->
          <brand-goods
            :pagesize="pagesize"
            :iconon="iconon"
            :iconoff="iconoff"
            :where="goodsWhere"
          />
        </div>
      </div>
    </div>

    <!--产品优势-->
    <div class="contents-goods-box" id="advantage">
      <div class="advantages contents" v-if="brandInfoAll.advantages">
        <div class="advantages-left">
          <img :src="brandInfoAll.advantages.advantages" />
        </div>
        <div class="advantages-right">
          <img
            :src="brandInfoAll.advantages.advantagesTitle"
            class="advantages-img"
          />

          <template v-if="brandInfoAll.advantages.type == 1">
            <p class="advantages-right-type1">
              {{ brandInfoAll.advantages.info }}
            </p>
          </template>

          <template v-if="brandInfoAll.advantages.type == 2">
            <p
              class="advantages-right-type1"
              v-for="(title, index) in brandInfoAll.advantages.info.names"
            >
              {{ title }}
            </p>
            <div
              class="advantages-right-type2"
              v-if="brandInfoAll.advantages.info.list.length > 0"
            >
              <ul>
                <li v-for="(info, index) in brandInfoAll.advantages.info.list">
                  <span>•</span>
                  <p>{{ info }}</p>
                </li>
              </ul>
            </div>
          </template>

          <template v-if="brandInfoAll.advantages.type == 3">
            <div class="advantages-right-type3">
              <template v-for="(info, index) in brandInfoAll.advantages.info">
                <p class="advantages-right-type3-title1">{{ info.name }}</p>
                <p class="advantages-right-type3-title2">
                  {{ info.list.name }}
                </p>
                <ul v-if="info.list.list && info.list.list.length > 0">
                  <li v-for="(tinfo, sindex) in info.list.list">
                    <span>•</span>
                    <p>{{ tinfo }}</p>
                  </li>
                </ul>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!--品牌切换图-->
    <div
      class="contents contents-certify"
      v-if="brandInfoAll.certify && brandInfoAll.certify.length > 0"
    >
      <div id="certify">
        <div class="swiper-container-brand">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(certify, index) in brandInfoAll.certify"
            >
              <img :src="certify.poster" />
              <p>{{ certify.title }}</p>
              <p>{{ certify.info }}</p>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="swiper-button-brand-prev"></div>
      <div class="swiper-button-brand-next"></div>
    </div>
    <!--普通应用行业-->
    <div class="contents-goods-box" id="industry">
      <div class="contents">
        <div class="contents about-contents-img">
          <img :src="industryTitleImg" />
        </div>
        <div class="p-industry-list">
          <!-- 335 200  -->
          <div
            class="p-industry-list-item"
            :class="{
              'p-industry-list-item-f': brandInfoAll.pindustry.length > 6
            }"
            v-for="(item, index) in brandInfoAll.pindustry"
            :style="{
              background: 'url(' + item.bjimg + ') no-repeat ' + '100% 100%'
            }"
          >
            <div class="p-industry-list-item-contents-box">
              <div class="p-industry-list-item-contents">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contents-goods-box" v-if="brandInfoAll.bigimg">
      <img class="bigimg" :src="brandInfoAll.bigimg" />
    </div>
    <!--普通关于我们-->
    <div
      class="contents-goods-box contents-goods-box-about-us"
      id="aboutus"
      v-if="brandInfoAll.aboutus"
    >
      <div class="contents p-about-contents">
        <img :src="brandInfoAll.aboutus.aboutusimg" />
      </div>
      <div class="p-about-us">
        <div class="p-about-us-left">
          <div class="p-about-us-left-contents">
            <p class="p-about-us-left-contents-title">
              {{ brandInfoAll.aboutus.title }}
            </p>
            <div class="characteristic-item-bottom">
              <div
                class="p-about-us-item-bottom-list"
                v-for="(item, index) in brandInfoAll.aboutus.list"
              >
                <i class="icon iconfont icon-yuandianzhong"></i>
                <p>{{ item }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="p-about-us-right">
          <img :src="brandInfoAll.aboutus.showimg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserCollectionInfo from "../../components/user/UserCollectionInfo.vue";
import Brandlist from "../../components/brand/brandlist.vue";
import BrandGoods from "../../components/brand/BrandGoods.vue";
import Brandsearch from "../../components/brand/brandsearch.vue";
//引用swiper
import Swiper from "swiper";
//引用swiper样式
import "swiper/swiper.min.css";

export default {
  data() {
    return {
      brandClassList: {},
      brandId: 1,
      brandInfo: {},
      goodsWhere: {},
      brandInfoAll: {
        metaInfo: {
          title: "",
          keywords: "",
          description: ""
        }
      },

      choose: "/static/brand/choose.png",
      nochoose: "/static/brand/nochoose.png",
      pagesize: 20,
      iconon: "icon iconfont icon-shoucang1",
      iconoff: "el-icon-star-off",
      industryTitleImg: "/static/brand/qingneng/hangye/hy.png",
      showindex: 1,
      initialSlide: 0
    };
  },
  components: { UserCollectionInfo, BrandGoods, Brandsearch, Brandlist },
  methods: {
    changetype(index) {
      //console.log(index)
      this.showindex = index;
    },
    //获取brandInfoAll
    getBrandInfoAll() {
      var res = this.$api.brand.getBrandInfo(this.brandId);
      this.brandInfoAll = res;
    },
    getBrandClass() {
      console.log(this.brandId);
      const res = this.$api.brand.getGoodsClass(this.brandId).then(res => {
        console.log(res);
        this.brandClassList = res.data.datas.cid2Arr;
        this.brandInfo = res.data.datas.brandInfo;
        this.brandClassList[0].isChecked = true;
      });
    },
    getBrandSwiper() {
      this.gallery = new Swiper(".swiper-container-brand", {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-brand-next",
          prevEl: ".swiper-button-brand-prev"
        },
        pagination: {
          el: ".swiper-pagination"
          //clickable :true,
        },
        on: {
          progress: function(progress) {
            //console.log(this.slides.length);
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              var translate = slideProgress * modify * 80 + "px"; //260
              var scale = 1 - Math.abs(slideProgress) / 5;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              //console.log(Math.abs(slideProgress))
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(swiper, transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      });
    },

    //选择分类
    checkClass(index) {
      for (var i in this.brandClassList) {
        this.brandClassList[i].isChecked = false;
        if (i + "" == index + "") {
          this.brandClassList[index].isChecked = true;
        }
      }
    },
    //选择选项
    checkitemClass(index, sindex, tindex) {
      for (var i in this.brandClassList[index].list[sindex].list) {
        this.brandClassList[index].list[sindex].list[i].isChecked = false;
      }

      this.brandClassList[index].list[sindex].list[tindex].isChecked = !this
        .brandClassList[index].list[sindex].list[tindex].isChecked;
      this.getGoodslist();
    },
    //重置所有搜索条件
    reset() {
      for (var i in this.brandClassList) {
        for (var j in this.brandClassList[i].list) {
          for (var m in this.brandClassList[i].list[j].list) {
            this.brandClassList[i].list[j].list[m].isChecked = false;
          }
        }
      }
      this.getGoodslist();
    },
    getGoodslist() {
      //整理条件
      this.goodsWhere = {};
      this.goodsWhere.attr = [];
      for (var i in this.brandClassList) {
        for (var j in this.brandClassList[i].list) {
          if (this.brandClassList[i].isChecked) {
            for (var m in this.brandClassList[i].list[j].list) {
              if (this.brandClassList[i].list[j].list[m].isChecked) {
                this.goodsWhere.attr.push(
                  this.brandClassList[i].list[j].list[m].id
                );
              }
            }
          }
        }
      }
      this.goodsWhere.brand_id = this.brandId;
    }
  },
  watch: {
    $route(to, from) {
      //监听URL地址栏参数变化
      //this.id = this.$route.params.id
      this.brandId = this.$route.params.id;
      this.getBrandInfoAll();
      this.$nextTick(function() {
        this.getBrandSwiper();
      });

      this.getBrandClass();
      this.getGoodslist();
    }
  },
  mounted() {
    this.brandId = this.$route.params.id;
    this.getBrandInfoAll();
    this.$nextTick(function() {
      this.getBrandSwiper();
    });

    this.getBrandClass();
    this.getGoodslist();
  },
  metaInfo() {
    return {
      title: this.brandInfoAll.metaInfo.title,
      meta: [
        { name: "keywords", content: this.brandInfoAll.metaInfo.keywords },
        { name: "description", content: this.brandInfoAll.metaInfo.description }
      ]
    };
  }
};
</script>

<style scoped>
.contents {
  overflow: hidden;
}
.body {
  background-color: #f4f5f7;
  overflow: hidden;
}
.navigation-line {
  font-size: 16px;
  margin-top: 25px;
}
.navigation-line .navigation {
  color: #333333;
}
/* .navigation-line .navigation .navigation-now{
        color: #2655AE;
    }   */
/**产品列表 */
.contents-goods-box {
  background-color: #fff;
  overflow: hidden;
}
.contents-goods-box .goods-box {
  width: 909px;
  float: right;
  margin-top: 78px;
  margin-bottom: 50px;
}
/**关于我们 */
.about-us {
  position: relative;
  overflow: hidden;
}
.about-contents {
  text-align: center;
  position: relative;
}
.about-contents-img {
  margin-top: 100px;
  margin-bottom: 60px;
  text-align: center;
}
.about-contents .about-contents-video,
.about-contents .about-contents-video video {
  width: 1104px;
  height: 621px;
}
.about-contents .about-contents-info {
  width: 1104px;
  margin-bottom: 50px;
  margin-top: 50px;
  /* position:absolute;
        left:0;
        top:0; */
}
.about-contents .about-contents-info p {
  font-size: 18px;
  line-height: 40px;
  color: #666666;
  text-indent: 2em;
  text-align: left;
}
.about-us-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 576px;
  background: url("/static/brand/aboutusbj.png") no-repeat;
}
.about-us-bottom {
  width: 100%;
  height: 663px;
  position: absolute;
  left: 0;
  top: 576px;
  background: url("/static/brand/aboutusbj2.png") no-repeat;
}

/**行业 */
.industry-list {
  background: url("/static/brand/aboutusbj.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.industry-list-item {
  width: 25%;
  height: 292px;
  position: relative;
  float: left;
}
.industry-list-item .industry-list-item-off {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 292px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 24px;
  color: #fff;
}
.industry-list-item .industry-list-item-on {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 292px;
  background-color: #fff;
}

/*     
    .industry-list-item-on-title{
        position: relative;
        width: 100%;
        height: 70px;
        background: url("http://www.movibot.com/brand/industry/inbj.png") no-repeat;
        background-size:100% 100%;
        margin-bottom: 42px;
    }
    .industry-list-item-on-title-info{
        width: 64px;
        height: 64px;
        position:absolute;
        top:38px;
        left:calc(50% - 32px);
        background: url("http://www.movibot.com/brand/industry/insonbj.png") no-repeat;
        background-size:100% 100%;
        text-align: center;
    } */
.industry-list-item-on-title-info img {
  width: 56px;
  height: 56px;
  margin-top: 4px;
}
.industry-list-item-on p {
  text-align: center;
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #444444;
  margin-bottom: 5px;
}
.industry-list-item-on ul li {
  text-align: center;
  color: #666666;
  font-size: 14px;
  line-height: 22px;
}
.industry-contents {
  margin-bottom: 50px;
}
.industry-contents-title {
  text-align: center;
  padding-top: 140px;
  margin-bottom: 110px;
}

/**产品特点 */
.characteristic-item {
  width: 375px;
  height: 452px;
  background-color: #fff;
  text-align: center;
}
.characteristic-item-top {
  margin-top: 37px;
}
.characteristic-item-top p {
  color: #333333;
  font-weight: 700;
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 15px;
}
.haracteristic-contents {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
.characteristic-item-bottom-list {
  width: 331px;
  margin-left: 22px;
  overflow: hidden;
}
.characteristic-item-bottom-list p {
  font-weight: 400;
  font-size: 20px;
  color: #666666;
  margin-top: 5px;
  display: inline-block;
  float: left;
  width: 314px;
}
.characteristic-item-bottom-list .icon {
  color: #fbb113;
  font-size: 15px;
  width: 17px;
  float: left;
  margin-top: 10px;
}
/**我们的服务 */
.service-list {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  margin-bottom: 110px;
}
.service-item {
  width: 25%;
  text-align: center;
  height: 536px;
}
.service-item .service-img {
  margin-top: 47px;
  margin-bottom: 33px;
  position: relative;
}
.service-item .service-img::after {
  position: absolute;
  top: 60px;
  right: 0;
  width: 1px;
  height: 90px;
  content: "";
  background-color: #dbdbdb;
}
.service-item:last-child .service-img::after {
  display: none;
}
.service-item .service-img img {
  width: 210px;
  height: 210px;
}
.service-item .service-info {
  text-align: left;
  padding: 0 23px;
  color: #666666;
  letter-spacing: 1.5px;
  font-size: 18px;
  line-height: 26px;
}
.service-item .service-title {
  color: #333333;
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 13px;
}

/**产品优势 */
.advantages {
  margin: 80px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.advantages-left {
  float: left;
  width: 667px;
}
.advantages-left img {
  width: 100%;
}
.advantages-right {
  float: right;
  width: 475px;
}
.advantages-right-type1 {
  font-size: 22px;
  color: #666;
  line-height: 2;
}
.advantages-right-type2 ul li {
  font-size: 16px;
  color: #999;
  line-height: 1.6;
}
.advantages-right-type2 ul li p {
  width: 455px;
  float: right;
}
.advantages-right-type2 ul li span {
  color: #fbb113;
}
.advantages-right-type3 {
  line-height: 1.6;
}
.advantages-right-type3 .advantages-right-type3-title1 {
  font-size: 22px;
  color: #333;
}
.advantages-right-type3 .advantages-right-type3-title2 {
  font-size: 16px;
  color: #666;
  line-height: 2;
}
.advantages-right-type3 ul li {
  font-size: 14px;
  color: #999;
  line-height: 2;
}
.advantages-right-type3 ul li p {
  width: 460px;
  float: right;
}
.advantages-right-type3 ul li span {
  color: #fbb113;
}

.advantages {
  overflow: hidden;
}
.advantages .advantages-img {
  margin-bottom: 20px;
}
.p-about-contents {
  background-color: #fff;
  text-align: center;
  margin-bottom: 20px;
}

/**品牌切换图 */
/* CSS Document */

#certify {
  position: relative;
  width: 935px;
  margin: 0 auto;
  overflow: hidden;
}

#certify .swiper-container-brand {
  padding-bottom: 60px;
}

#certify .swiper-slide {
  width: 390px;
  height: 390px;
  background: #fff;
  box-shadow: 0 8px 30px #ddd;
  flex-direction: column;
}
#certify .swiper-slide img {
  display: block;
  width: 390px;
}
#certify .swiper-slide p {
  line-height: 2;
  padding-top: 0;
  color: #666;
  font-size: 18px;
  margin: 0 30px;
}

#certify .swiper-pagination {
  width: 100%;
  bottom: 20px;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 5px;
  border: 3px solid #fff;
  background-color: #d5d5d5;
  width: 10px;
  height: 10px;
  opacity: 1;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
  border: 3px solid #00aadc;
  background-color: #fff;
}

.swiper-button-brand-prev {
  left: 40px;
  top: 172px;
  width: 45px;
  height: 45px;
  background: url(/static/wm_button_icon.png) no-repeat;
  background-position: 0 0;
  background-size: 100%;
  position: absolute;
}

.swiper-button-brand-prev:hover {
  background-position: 0 -46px;
  background-size: 100%;
}
.swiper-button-brand-next {
  right: 40px;
  top: 172px;
  width: 45px;
  height: 45px;
  background: url(/static/wm_button_icon.png) no-repeat;
  background-position: 0 -93px;
  background-size: 100%;
  position: absolute;
}

.swiper-button-brand-next:hover {
  background-position: 0 -139px;
  background-size: 100%;
}
.swiper-button-brand-prev::after,
#certify .swiper-button-brand-next::after {
  content: "";
}
.contents-certify {
  position: relative;
  margin-top: 80px;
}
/**普通应用行业 */
.p-industry-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.p-industry-list-item {
  position: relative;
  width: 335px;
  height: 335px;
  background-color: red;
  margin-bottom: 97px;
  border-radius: 20px;
}
.p-industry-list-item.p-industry-list-item-f {
  width: 202px;
  height: 202px;
  margin-bottom: 55px;
  border-radius: 10px;
  background-size: 100% 100% !important;
}
/* .p-industry-list-item:hover{
    background-color: rgba(0, 0, 0, 0.1);
    opacity:0.5
} */
.p-industry-list-item .p-industry-list-item-contents-box {
  display: none;
  width: 335px;
  height: 335px;
  overflow: hidden;
}
.p-industry-list-item.p-industry-list-item-f
  .p-industry-list-item-contents-box {
  display: none;
  width: 202px;
  height: 202px;
  overflow: hidden;
}
.p-industry-list-item:hover .p-industry-list-item-contents-box {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 25px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
.p-industry-list-item .p-industry-list-item-contents {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: 80%;
  height: 80%;
  border: 3px solid rgb(255, 255, 255, 0.5);
}

/* .p-industry-list-item-f .p-industry-list-item-contents{
    width: 172px;
    height: 172px;
} */
.p-industry-list-item .p-industry-list-item-contents span {
  opacity: 1;
}

/**普通关于我们 */
.p-about-us {
  min-width: 1200px;
  overflow: hidden;
  margin-bottom: 50px;
}
.p-about-us-left {
  width: calc(50% - 100px);
  float: left;
}
.p-about-us-left-contents {
  width: 500px;
  float: right;
}
.p-about-us-right {
  width: calc(50% + 60px);
  float: right;
}
.p-about-us-right img {
  width: 100%;
}

.p-about-us-item-bottom-list {
  width: 500px;
  overflow: hidden;
  margin-top: 30px;
}
.p-about-us-item-bottom-list p {
  font-weight: 400;
  font-size: 20px;
  color: #666666;
  margin-top: 5px;
  display: inline-block;
  float: left;
  width: 483px;
}
.p-about-us-item-bottom-list .icon {
  color: #2655ae;
  font-size: 15px;
  width: 17px;
  float: left;
  margin-top: 10px;
}
.p-about-us-left-contents-title {
  font-size: 22px;
  color: #2655ae;
}

.bigimg {
  width: 100%;
}
.contents-goods-box-about-us {
  padding-top: 50px;
  padding-bottom: 50px;
  overflow: hidden;
}
.allbrand {
  color: #333333;
}
.navigation .icon-yuanquan_huaban1 {
  color: #fbb113;
}
.navigation {
  float: right;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.nowshow {
  color: #666;
}
.navigation-now {
  color: #888;
}
.navigation a:hover {
  color: #2655ae;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/brand/info.vue